// extracted by mini-css-extract-plugin
export default {"store_icon":"styled_store_icon__8clZw"};